import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { inject } from 'mobx-react'
import { withRouter } from 'react-router-dom'
import ACL from '@components/ACL'

import Action from '@components/Action'
import DeleteIcon from '@components/Icon/Delete'
import Link from '@components/Icon/Link'
import Edit from '@components/Icon/Edit'
import { showDialog, isCancellationError } from '@components/Dialog'

class Actions extends Component {
  static propTypes = {
    modalStore: PropTypes.object,
    history: PropTypes.object,
    contractStore: PropTypes.object,
    growlStore: PropTypes.object
  }

  deleteContract = contractId => {
    const { contractStore, history, growlStore } = this.props
    const { contractReference } = contractStore.contract
    return showDialog({
      title: 'Delete this contract?',
      text: contractReference,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Delete'
    })
      .then(() => {
        return contractStore.deleteContract(contractId).then(() => {
          const url = history.location.pathname
          const regex = /\/client-search\/parent-account\/[0-9]*\/contracts\/[0-9]*$/
          const contract = contractStore.contract
          if (regex.test(url)) {
            history.push(
              `/client-search/parent-account/${contract.parentAccountId}/contracts`
            )
          } else {
            history.push('/contract-search')
          }
        })
      })
      .catch(err => {
        if (isCancellationError(err)) return
        growlStore.showError(
          err,
          `Couldn't delete contract ${contractReference}`
        )
      })
  }

  render () {
    const { contractStore } = this.props
    const { contract } = contractStore
    return (
      <div className='actions-wrapper'>
        <ACL roles={['AdvancedReporting', 'Admin']}>
          <ul className='actions'>
            <li>
              <Action
                onClick={() => {
                  return this.props.modalStore.show({
                    type: 'LINKED_CONTRACTS_FORM',
                    props: {
                      title: 'Link contracts',
                      okText: 'Save',
                      cancelText: 'Cancel',
                      contractStore
                    }
                  })
                }}
              >
                <Link />
                <span>Link to contracts</span>
              </Action>
            </li>
            {contract.contractTypeId !== 1 ? (
              <li>
                <Action
                  disabled={contract.contractBalance === 0}
                  onClick={() => {
                    return this.props.modalStore.show({
                      type: 'ROLLOVER_CREDITS_FORM',
                      props: {
                        title: 'Rollover credits',
                        okText: 'Save',
                        cancelText: 'Cancel',
                        contractStore,
                        contract
                      }
                    })
                  }}
                >
                  <Link />
                  <span>Rollover credits</span>
                </Action>
              </li>
            ) : null}
            <li>
              <Action
                onClick={() => {
                  return this.props.modalStore.show({
                    type: 'CONTRACT_FORM',
                    props: {
                      contract,
                      contractStore,
                      feeCount: contractStore.feeCount,
                      title: `Edit contract`,
                      okText: 'Save',
                      cancelText: 'Cancel'
                    }
                  })
                }}
              >
                <Edit />
                <span>Edit</span>
              </Action>
            </li>
            <li
              className='action'
              onClick={() => {
                this.deleteContract(this.props.contractStore.contract.id)
              }}
            >
              <Action>
                <DeleteIcon />
                <span>Delete</span>
              </Action>
            </li>
          </ul>
        </ACL>
      </div>
    )
  }
}

export default withRouter(inject('modalStore', 'growlStore')(Actions))
